<template>
	<div class="mainContentBackground villageBackground unselectable">
		<div class="sea viewBackground" :style="{top: '0px', left: villageBackgroundLeft, right: 'auto', height: '1440px', transform: 'perspective(1000px) scale3d(1, 1, 1)', transformOrigin: '50% 50%', filter: 'blur(0px)', perspective: '1000px'}">
			<div class="modalWrapper building" style="opacity: 1; top: 400px; align-items: flex-start; justify-content: center; display: flex; width: 100%; height: 100%;">
				<div class="modal building">
					<div class="modalContent">
						<div class="modalDecoration"></div>
						<div class="functionPanel unselectable">
							<a class="closeWindow clickable" @click="$router.push('/township')">
								<div class="decoration" content="Закрыть" v-tippy="{placement: 'bottom'}">
									<i class="action_cancel_tiny_flat_black"></i>
								</div>
							</a>
						</div>
						<div class="contentHeader unselectable">
							<div>
								<h2 class="msAntiScroll drag" draggable="true">
									<span class="building"><span>Дом</span></span>
									<span class="level">
										(<span>Уровень {{gameModel.island.buildings.house.level}}</span>)
									</span>
								</h2>
								<div class="buildingDescription">
									<span>Чем выше уровень дома, тем меньше времени будут строиться другие здания.</span>
								</div>
								<img class="buildingHuge buildingType15 tribeId3 level5" src="//iwstatic.g.bsrv.su/img/x.gif" />
							</div>
							<span class="buildingStatusButton type_15">
								<div class="buildingStatus location27 optionMenu">
									<div class="buildingBubble clickable disabledHover">
										<div class="colorLayer notNow enoughRes">
											<div class="labelLayer">
												<span class="buildingLevel">5</span>
											</div>
										</div>
									</div>
								</div>
							</span>
						</div>
						<div class="heightTransitionContent" :style="{maxHeight: maxHeightContent}">
							<div class="contentTabulation">
								<nav class="tabulation  maintab unselectable">
									<a class="tab clickable" :class="{active: tab == 'overview', inactive: tab != 'overview'}" @click="onToggleTab('overview')">
										<div class="content">
											<span>Обзор</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'build', inactive: tab != 'build'}" @click="onToggleTab('build')">
										<div class="content">
											<span>Строительство</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'champions', inactive: tab != 'champions'}" @click="onToggleTab('champions')">
										<div class="content">
											<span>Чемпионы</span>
										</div>
									</a>
									<a class="tab clickable" :class="{active: tab == 'tab4', inactive: tab != 'tab4'}" @click="onToggleTab('tab4')">
										<div class="content">
											<span>Tab4</span>
										</div>
									</a>
								</nav>
								<div class="tabulationContent scrollable tabContent">
									<div class="scrollContentOuterWrapper">
										<div class="scrollContent" style="overflow-y: auto;" :style="{maxHeight: maxHeightInnerContent}">
											<div class="scrollContentInnerWrapper" style="width: auto;">
												<div class="building buildingType15">
													<div class="buildingDetails mainBuilding">
														<div class="loadedTab currentTab tabVillage" v-if="tab == 'overview'">
															<overview />
														</div>
														<div class="loadedTab currentTab" v-if="tab == 'build'">
															<build />
														</div>
														<div class="loadedTab currentTab tabChampions" v-if="tab == 'champions'">
															<champions />
														</div>
														<div class="loadedTab currentTab" v-if="tab == 'tab4'">
															tab4
															<span v-tippy="{placement: 'top', content: h(tooltips.test, {name: 'hello world'})}">tatata</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="window-overlay">
							
							<!-- основать город? -->
							<town-founding v-if="gameModel.buildings.house.townFoundingShow" />
							
							<!-- улучшить чемпиона -->
							<upgrade-champion v-if="gameModel.buildings.house.upgradeChampionShow" />
							
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { h } from 'vue';
import { useMeta } from 'vue-meta';

import Overview from '@/components/pages/buildings/house/Overview';
import Build from '@/components/pages/buildings/house/Build';
import Champions from '@/components/pages/buildings/house/Champions';

import TownFounding from '@/components/pages/buildings/house/windowOverlay/TownFounding';
import UpgradeChampion from '@/components/pages/buildings/house/windowOverlay/UpgradeChampion';
import TestTippy from '@/components/tooltips/TestTippy';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Дом | IW'});
	},
	data: () => ({
		maxHeightContent: '550px',
		maxHeightInnerContent: '530px',
		cancelHover: false,
		
		tab: 'overview',
		selBuilding: '',
		
		villageBackgroundLeft: '0px',
		
		tooltips: {
			test: TestTippy,
		},
	}),
	computed: {},
	methods: {
		h,
		
		onModalOpen() {
			if (this.gameModel.soundOn) {
				let audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_20.ogg');
				audio.play();
			}
		},
		onModalClose() {
			if (this.gameModel.soundOn) {
				let audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_7.ogg');
				audio.play();
			}
		},
		onToggleTab(tab) {
			this.tab = tab;
			
			if (this.gameModel.soundOn) {
				let audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_8.ogg');
				audio.play();
			}
		},
		onToggleBuilding(building) {
			if (this.gameModel.soundOn) {
				let audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/T5UIS_21.ogg');
				audio.play();
			}
			
			this.selBuilding = building;
		},
		
		onResize() {
			//let leftpos = (window.innerWidth / 2) - (1920 / 2) - 70;
			let leftpos = (window.innerWidth / 2) - (1920 / 2);
			//console.log(window.innerWidth, leftpos);
			this.villageBackgroundLeft = leftpos+'px';
			
			let maxHeightContent = window.innerHeight - 375;
			maxHeightContent = (maxHeightContent < 500 ? 500 : maxHeightContent);
			this.maxHeightContent = maxHeightContent + 'px';
			this.maxHeightInnerContent = (maxHeightContent - 57 > 0 ? maxHeightContent - 57 : 0) + 'px';
		},
	},
	mounted() {
		this.onModalOpen();
		
		window.addEventListener('resize', this.onResize);
		this.onResize();
		
		if (this.$route.query.tab) this.tab = this.$route.query.tab;
		else this.$router.push({query: {tab: this.tab}});
	},
	unmounted() {
		this.onModalClose();
		
		window.removeEventListener('resize', this.onResize); 
	},
	beforeRouteUpdate(to, from, next) {
		if (!to.query.tab) this.$router.push({query: {tab: 'overview'}});
		else if (to.query.tab != this.tab) this.tab = to.query.tab;
		next();
	},
	created() {
		this.gameModel.buildingQueue.show = true;
	},
	components: {
		Overview,
		Build,
		Champions,
		
		TownFounding,
		UpgradeChampion,
	},
}
</script>
